'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'tv-retro';
var width = 512;
var height = 512;
var aliases = [128250];
var unicode = 'f401';
var svgPathData = 'M163.9 12L151.7 1.6 130.9 25.8l12.1 10.4L212.7 96 32 96 0 96l0 32L0 480l0 32 32 0 448 0 32 0 0-32 0-352 0-32-32 0L299.3 96l69.7-59.7 12.2-10.4L360.3 1.6 348.1 12 256 90.9 163.9 12zM256 128l224 0 0 352L32 480l0-352 224 0zm96 64l0 224L96 416l0-224 256 0zM96 160l-32 0 0 32 0 224 0 32 32 0 256 0 32 0 0-32 0-224 0-32-32 0L96 160zm336 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTvRetro = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;